import { render, staticRenderFns } from "./mpartner.vue?vue&type=template&id=4735ae10"
import script from "./mpartner.vue?vue&type=script&lang=js"
export * from "./mpartner.vue?vue&type=script&lang=js"
import style0 from "./mpartner.vue?vue&type=style&index=0&id=4735ae10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports